<template>   
  <v-jumbotron>
    <v-container class="flex" fill-height>
      <v-layout align-center>
        <v-flex class="flex-col">
          <line-chart v-if="!this.depthProfileLoading && this.depthProfile.distance > 0"
            :chart-data="depthData"
            :options="{responsive: false, maintainAspectRatio: false}"
            :width="600"            
            :height="300"></line-chart>                      
          <div class="text-xs-center" v-if="depthProfileLoading" >
            <v-progress-circular                        
              :size="70"
              :width="7"
              indeterminate
            ></v-progress-circular>          
          </div>
          <v-divider class="my-3"></v-divider>          
          <div class="caption">{{$t('Pilot.DepthProfile.DataSource')}} {{depthProfileProvider}}</div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>   
</template>
<script>  
  import { mapGetters } from 'vuex'    
  import MapToolList from '@/components/map/MapToolList'
  import LineChart from '@/components/charts/LineChart'

  export default {    
    name: 'DepthProfilDialog',   
    components: {LineChart},
    computed: {
      ...mapGetters([
        'depthProfile',
        'depthProfileLoading',
        'depthProfileProvider' 
      ]),
      depthData() {          
        //this.depthProfile
        const offset = this.depthProfile.distance / parseFloat(this.depthProfile.depths.length - 1)        
        const chartData = { 
          labels: this.depthProfile.depths.map((it,index) =>  this.$options.filters.formatDistance(index * offset)),
          datasets: [
            {
              label: 'Depth (m)',
              backgroundColor: '#87CEEB',
              data: this.depthProfile.depths//.map(it => -it)
            }
          ]
        }        
        return chartData
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>

</style>
